var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirCargoService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b52f28",
    d: "M5 35a3 3 0 0 1-3-3V16h4l6 9h43a7 7 0 0 1 7 7 3 3 0 0 1-3 3z",
    opacity: 1,
    "data-original": "#b52f28",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d23f34",
    d: "M46 25H12l-6-9H2v13h41a3 3 0 0 0 3-3z",
    opacity: 1,
    "data-original": "#d23f34",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8cded",
    d: "M42 21a4 4 0 0 0 0-8c-.042 0-.081.011-.123.012A4.249 4.249 0 0 0 42 12c0-2.761-2.686-5-6-5s-6 2.239-6 5a4.249 4.249 0 0 0 .123 1.012c-.042 0-.081-.012-.123-.012a4 4 0 0 0 0 8z",
    opacity: 1,
    "data-original": "#c8cded"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e2e7f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.929 31H54a4 4 0 0 1-4-4v-2h5a7 7 0 0 1 6.929 6zM58 18a4 4 0 0 0 0-8c-.042 0-.081.011-.123.012A4.249 4.249 0 0 0 58 9c0-2.761-2.686-5-6-5s-6 2.239-6 5a4.249 4.249 0 0 0 .123 1.012c-.042 0-.081-.012-.123-.012a4 4 0 0 0 0 8zM46 31l-9 14h-3l3-14z",
    fill: "#e2e7f6",
    opacity: 1,
    "data-original": "#e2e7f6",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m37 31-3 14 9-14z",
    opacity: 1,
    "data-original": "#f2f2f2",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 46,
    r: 14,
    fill: "#e2e7f6",
    opacity: 1,
    "data-original": "#e2e7f6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M16 32A14 14 0 0 0 5.153 54.847a14 14 0 0 0 19.694-19.694A13.941 13.941 0 0 0 16 32z",
    opacity: 1,
    "data-original": "#f2f2f2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "M7 40h18v12H7z",
    opacity: 1,
    "data-original": "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5b5b5",
    d: "m25 52-7-7h-4l-7 7z",
    opacity: 1,
    "data-original": "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "m7 40 9 6 9-6",
    opacity: 1,
    "data-original": "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M58 25.677A6.975 6.975 0 0 0 55 25h-5v2a3.955 3.955 0 0 0 .555 2H56a2 2 0 0 0 2-2zM55.779 8.583a10.387 10.387 0 0 0-.761-3.9A6.908 6.908 0 0 0 52 4c-3.314 0-6 2.239-6 5a4.249 4.249 0 0 0 .123 1.012c-.042 0-.081-.012-.123-.012a4 4 0 0 0 0 8h3.794a10.408 10.408 0 0 0 5.985-9.417z",
    opacity: 1,
    "data-original": "#f2f2f2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2e7f6",
    d: "M39.779 11.583a10.387 10.387 0 0 0-.761-3.9A6.908 6.908 0 0 0 36 7c-3.314 0-6 2.239-6 5a4.249 4.249 0 0 0 .123 1.012c-.042 0-.081-.012-.123-.012a4 4 0 0 0 0 8h3.794a10.408 10.408 0 0 0 5.985-9.417z",
    opacity: 1,
    "data-original": "#e2e7f6",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCargoService);
export default __webpack_public_path__ + "static/media/air_cargo_service.c3bd9e71b044107ab23e49f60b77ca35.svg";
export { ForwardRef as ReactComponent };